import { formatDayMonth, formatWeekdayDayMonth } from '../../../utils/dateFormat';

/** Monday at 00:00 of the week containing `date` (interpreted in local time). */
export function mondayOf(date: Date): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const day = d.getDay(); // 0 = Sun
  const offset = day === 0 ? -6 : 1 - day;
  d.setDate(d.getDate() + offset);
  return d;
}

/** Sunday at 23:59:59.999 of the week containing `date`. */
export function sundayOf(date: Date): Date {
  const mon = mondayOf(date);
  const sun = new Date(mon);
  sun.setDate(sun.getDate() + 6);
  sun.setHours(23, 59, 59, 999);
  return sun;
}

/** "YYYY-MM-DD" for the Monday. */
export function mondayKey(date: Date): string {
  const m = mondayOf(date);
  const y = m.getFullYear();
  const mm = String(m.getMonth() + 1).padStart(2, '0');
  const dd = String(m.getDate()).padStart(2, '0');
  return `${y}-${mm}-${dd}`;
}

export function addWeeks(date: Date, weeks: number): Date {
  const d = new Date(date);
  d.setDate(d.getDate() + weeks * 7);
  return d;
}

/** "6 Oct – 12 Oct". */
export function formatWeekRange(monday: Date): string {
  return `${formatDayMonth(monday)} – ${formatDayMonth(sundayOf(monday))}`;
}

/** "Mon 6 Oct". */
export function dayLabel(date: Date): string {
  return formatWeekdayDayMonth(date);
}
